import {IGameFilterDefinition} from '../interfaces/game-filter-definition.interface';
import {GameInfo} from '../../games/game-info';
import {SubgroupNameFilter} from "./subgroup-name.filter";
import {ApplyGameFilterResult} from "../interfaces/game-filter-evaluator.interface";

export class AllPokerFilter implements IGameFilterDefinition {

    readonly id = 'all-poker';


    applyFilter(gameInfo: GameInfo): ApplyGameFilterResult {
        if(gameInfo.gameGroup.toLowerCase().indexOf('poker') !== -1
            || ApplyGameFilterResult.IncludeGame === new SubgroupNameFilter('live-poker', 'poker').applyFilter(gameInfo)) {
            return ApplyGameFilterResult.IncludeGame;
        }
        return ApplyGameFilterResult.ExcludeGame;
    }
}
